export default __webpack_public_path__ + "static/media/emptyStateConsent.05726ff6.png";